import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoSpotify = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.9 13.3a1 1 0 0 0 .6.2 1.001 1.001 0 0 0 .62-1.8 7.89 7.89 0 0 0-8.61-.59 1 1 0 0 0 1 1.72 5.87 5.87 0 0 1 6.39.47Z"
    />
    <path
      fill="currentColor"
      d="M14 16.5a1 1 0 0 1-.83-.45c-.66-1-2.53-.94-3.62-.22a1 1 0 1 1-1.1-1.66c1.91-1.28 5-1.22 6.38.78a1 1 0 0 1-.28 1.38.94.94 0 0 1-.55.17ZM16.47 10.35a1 1 0 0 0 .53.15 1 1 0 0 0 .85-.5 1 1 0 0 0-.28-1.35 11.23 11.23 0 0 0-11-.54 1 1 0 0 0 .9 1.78 9.23 9.23 0 0 1 9 .46Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.444 20.315a10 10 0 1 0 11.112-16.63 10 10 0 0 0-11.112 16.63ZM7.555 5.348a8 8 0 1 1 8.89 13.304 8 8 0 0 1-8.89-13.304Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLogoSpotify;
